import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Alert } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';
import CommonPagination from '../components/CommonPagination';

import CommonToast from '../components/CommonToast';
import CommonConfirmModal from '../components/CommonConfirmModal';
import CommonAlert from '../components/CommonAlert';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonButton from '../components/CommonButton';
import CommonDropdown from '../components/CommonDropdown';
import CommonFile from '../components/CommonFile';
import CustomDatePicker from "../components/CommonDatePicker";

import CommonLoadingBar from '../components/CommonLoadingBar';

import CommonPreviewFileModal from '../components/CommonPreviewFileModal';

import CommonTokenExpired from '../components/CommonTokenExpired';

import * as constants from '../../config/constants/AppConstants';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

import { GlobalStates } from '../states/GlobalStates';

/** individual page state */
import { PageDataState } from '../states/SupplyDataSupplyHrInOutState';

/** requester handle */
import requester from "../../library/Requester"; 

/** define end point */
const TABLE = `supply_hr_in_out`;
const URL = `api/master/${TABLE}`;

const PARENT = 'supply_hr_id';

class InlineSupplyDataSupplyHrInOut extends Component {

    constructor(props){
        super(props);

        this.state = {...GlobalStates, ...PageDataState};
        this.updateState = this.setState.bind(this);

        this.inlineInputRowRef = React.createRef();
    }

    initialize = async () => {
        let {fkId, fkVal} = this.props;
        
        await Actions.parametersInline(this.updateState, PARENT, {id: fkId, value: fkVal});
        
        if (fkId && fkVal) {
            await this.loadMasterbase();
            await this.loadDataTable();
            await this.setDefaultInputs();
        }
    }    

    loadMasterbase = async () => {        
        let sets = [
            {key: "education_level", filter: [{ field: 'status', value: '0' }]}
        ];

        Actions.loadMasterbase(this.updateState, sets);
    }    

    loadDataTable = async (search=false) => { 
        const { Searchs, DataTable } = this.state;
        await Actions.loadDataTable( 
            this.updateState, 
            `${URL}/pagination`, 
            fn.getInputSearch({...Searchs, page: { id: 'page', value: search ? 1 : DataTable.pagination.currentPage }})
        );
    }

    updateSomething = async (obj, element, pk) => {
        await Actions.updateSomething(this.updateState, `${URL}/update-something`, element, pk, obj, this.loadDataTable);
    }

    reorder = async (obj) => {
        await Actions.reorder(this.updateState,`${URL}/reorder`, obj, this.loadDataTable);
    }

    setDefaultInputs = async () => {
        await Actions.setDefaultInputs(this.updateState, PARENT, async () => {
            /** 
            const { Action, Inputs } = this.state;
        
            if (['new', 'confirm-delete'].includes(Action.Mode) && Action.Inline.show === true) {
                let sequenceField = 'seq';
                let filterField = 'external_user_id';
                let result = await Actions.getMaxSequence(this.updateState, URL + '/get-max-sequence', {sequenceField: sequenceField, filter: [{field: filterField, value: Inputs[filterField].value}]});
                if(result.success){ Inputs[sequenceField].value = result.seq; }
                this.setState({Inputs: Inputs});
            }
            */
        });
    }    

    fetchForEdit = async (obj) => {
        await Actions.fetchForEdit(
            this.updateState,
            `${URL}/${obj.id}`, 
            {element: 'Inline', mode: 'update', bool: true}
        );

        setTimeout(() => {
            if (this.inlineInputRowRef && this.inlineInputRowRef.current) {
                this.inlineInputRowRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        }, 100);         
    }

    resetInlineInputs = () => {
        Actions.handleResetActionInline(this.updateState);
        Actions.handleDiscardInputs(this.updateState, 'Inputs');
        this.setDefaultInputs();
    }
                                                          
    submitData = async () => {
        const { Action, Inputs, DataTable } = this.state; 
        await Actions.submitData(
            this.updateState,
            `${URL}`,
            Action.Mode, 
            fn.getInputForm({...Inputs}),
            this.loadDataTable        
        );

        let result = this.state.Action.Alert.mode;
        
        if(['new-success', 'update-success'].includes(result)){ 
            this.resetInlineInputs();
        }
    }

    deleteData = async () => {
        const { Deletes } = this.state;
        await Actions.deleteData(this.updateState, `${URL}`, Deletes, this.loadDataTable);
        await this.setDefaultInputs();
    }
   
    componentDidMount = async () => { 
        await this.initialize();
    };

    componentDidUpdate = async (prevProps) => {
        if (prevProps.fkVal !== this.props.fkVal && !util.isEmpty(this.props.fkVal)) {
            await this.initialize();
        }        
    }

    render = () => {

        let { Action, DataTable, Inputs, Masterbase, Deletes, Operation, Parameters, Token } = this.state;

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let deleteChecked = 0;

        let { show, mode } = Action.Inline;

        let { Submit } = Operation;

        let isLoading = Action.Loading.submit;

        const isFk = Parameters[PARENT]?.parameters?.element?.find(item => item.id === PARENT)?.value ?? null; 

        return (
            <Container fluid className="data-table-container">

                <CommonTokenExpired Token={Token} />
                
                <CommonPreviewFileModal
                    Action={Action}
                    onClose={() => Actions.handleClosePreviewFile(this.updateState)}
                />

                <CommonToast 
                    toast={Action.Toast} 
                    onCloseToast={(e) => Actions.handleCloseToast(this.updateState)}
                />

                <CommonConfirmModal 
                    Action={Action}
                    Deletes={Deletes}

                    onCallback={async (e) => { 
                        let result = await Actions.handleControlModal(this.updateState, e);
                        if(result.action){
                            if (result.section === 'Delete'){ await this.deleteData(); }
                        }
                    }}
                />

                {util.isEmpty(isFk) ? 
                    <Alert key="light" variant="danger" className="custom-alert-border">
                        <i className="fa-classic fa-light fa-circle-exclamation fa-fw me-2"></i>
                         กรุณาบันทึก ผลผลิตกำลังคน ก่อนดำเนินการ บันทึก นักศึกษา
                    </Alert>                
                :
                    <>
                        <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
            
                        <Row>
                            <Col md={12}>
                                <>
                                    <Table 
                                        responsive 
                                        borderless 
                                        className={`table-advance ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                                        style={{marginTop: '0px'}}
                                    >
                                        <thead>
                                            <tr>
                                                <th className="th-td-align-center th-width-50p th-font-sm">#</th>
                                                <th className="th-td-align-center th-width-175p th-font-sm">ปี</th>  
                                                <th className="th-td-align-center th-width-auto th-font-sm">ระดับการศึกษา</th> 
                                                <th className="th-td-align-center th-width-175p th-font-sm">เข้ารับการศึกษา (คน)</th> 
                                                <th className="th-td-align-center th-width-175p th-font-sm">สำเร็จการศึกษา (คน)</th>                                      
                                                <th className="th-width-75p"></th>
                                                <th className="th-td-align-center th-width-75p">
                                                    {DataTable?.rows?.length > 0 && !!Deletes?.deletes?.length && (
                                                        <CommonButton 
                                                            task="delete-no-text" 
                                                            rounded={true}
                                                            disabled={false}
                                                            callback={(e) => 
                                                                Actions.handleControlModal(this.updateState, {mode: 'confirm-delete', show: true, action: false})
                                                            } 
                                                        />
                                                    )}                                          
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {DataTable.rows.map((row, index) => {
                                                    
                                                Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });

                                                rowId++;

                                                let del = true;

                                                return (    
                                                    <React.Fragment key={`${rowId}-${row.id}`}>
                                                        <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                            <td className="th-td-align-center td-font-sm align-top">
                                                                <CommonRowId rowId={rowId}/>
                                                            </td>
                                                            <td className="td-font-sm align-top text-center">
                                                                {row.years}                                                                                                                                                                                              
                                                            </td>                                                              
                                                            <td className="td-font-sm align-top" title={row.education_level_name}>
                                                                {row.education_level_name}                                                                                                                                                                                              
                                                            </td>     
                                                            <td className="td-font-sm align-top text-end">
                                                                {util.formatNumber(row.entry_amount)}                                                                                                                                                                                              
                                                            </td>  
                                                            <td className="td-font-sm align-top text-end">
                                                                {util.formatNumber(row.release_amount)}                                                                                                                                                                                              
                                                            </td>                                                                                                                                                                                
                                                            <td className="th-td-align-center align-top">
                                                                <CommonButton 
                                                                    task="edit" 
                                                                    rounded={false}
                                                                    disabled={false}
                                                                    inlineClass="btn-font-sm"
                                                                    callback={(e) => this.fetchForEdit({id: row.id})} 
                                                                />
                                                            </td>
                                                            <td className="th-td-align-center align-top">
                                                                {del && (
                                                                    <Form.Check 
                                                                        type="checkbox"
                                                                        name="deletes"
                                                                        value={row.id}
                                                                        checked={Deletes.deletes.includes(row.id)}
                                                                        onChange={(e) => Actions.handleDataTableToggleDelete(this.updateState, e)} 
                                                                        className="checkbox-font-sm" 
                                                                    />
                                                                )}                                                        
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>                                
                                                )
                                            })}

                                            <React.Fragment key={`inline-input-form`}>
                                                <tr ref={this.inlineInputRowRef}>
                                                    <td className="th-td-align-center align-top"><i className="fa-classic fa-light fa-circle-arrow-right fa-fw"></i></td>   
                                                    <td className="align-top">
                                                        <CommonSelect
                                                            element="Inputs"
                                                            input={Inputs.years}
                                                            option={{source: 'db', data: Masterbase?.yearBEOptions}}
                                                            size="sm"
                                                            hr={false}
                                                            floatingLabel={false}
                                                            callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                                                        />                                                    
                                                    </td>                                                    
                                                    <td className="align-top">
                                                        <CommonSelect
                                                            element="Inputs"
                                                            input={Inputs.education_level_id}
                                                            option={{source: 'db', data: Masterbase?.education_level || []}}
                                                            size="sm"
                                                            hr={false}
                                                            floatingLabel={false}
                                                            callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                                                        />                                                    
                                                    </td>
                                                    <td className="align-top">
                                                       <CommonInput
                                                            element="Inputs"
                                                            input={Inputs.entry_amount}
                                                            size="sm"
                                                            hr={false}
                                                            floatingLabel={false}
                                                            callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                                                        />                                                          
                                                    </td>
                                                    <td className="align-top">
                                                       <CommonInput
                                                            element="Inputs"
                                                            input={Inputs.release_amount}
                                                            size="sm"
                                                            hr={false}
                                                            floatingLabel={false}
                                                            callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)}                                                            
                                                        />                                                          
                                                    </td>                                                    
                                                    <td colSpan = "2" className="align-top">
                                                        <div className="d-flex justify-content-center">
                                                            <CommonButton 
                                                                task={`${mode}-no-text`} 
                                                                disabled={isLoading ? true : Submit ? false : true}
                                                                callback={async (e) => await this.submitData() }
                                                            /> 
                                                            <CommonButton 
                                                                task="discard-no-text" 
                                                                inlineClass="ms-2" 
                                                                disabled={isLoading} 
                                                                callback={(e) => this.resetInlineInputs()}
                                                            />     
                                                        </div>                                                                                
                                                    </td>                                                                                             
                                                </tr>
                                            </React.Fragment>


                                        </tbody>
                                    </Table>    
                                    
                                    <CommonAlert 
                                        alert={Action.Alert} 
                                        size="sm"
                                        callback={(e) => Actions.handleCloseAlert(this.updateState, 'Alert', e)}
                                    />    

                                    <CommonLoadingBar isLoading={isLoading} />   

                                    {!DataTable?.rows?.length > 0 && (
                                        <>{/** <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} /> */}</>  
                                    )}                                                    
                                </>   

                                {!Action.Loading.dataTable && (DataTable.pagination.totalPages > 1) && (
                                    <CommonPagination 
                                        Pagination={DataTable.pagination} 

                                        handlePagination={(paging) => {
                                            Actions.handleDataTablePaginationChange(this.updateState, paging, this.loadDataTable)                                    
                                        }}
                                    />
                                )}
                            </Col>
                        </Row>
                    </>
                }
            </Container>                        
        )
    }
}

export default InlineSupplyDataSupplyHrInOut;